import * as React from 'react';
import Divider from 'material-ui/Divider';
import Subheader from 'material-ui/Subheader';
import List from 'material-ui/List/List';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import Popover from 'material-ui/Popover';

import ListItemPlus from './ListItemPlus';
import TopVoters from "./TopVoters";

interface ISongVotersProps {
    voters : Array<any>;
    userClickHandler(event : any): void;
    fallbackImage : string;
}

interface ISongVotersState {
    open : boolean;
    anchorEl? : React.ReactInstance;
}

class SongVoters extends React.Component<ISongVotersProps, ISongVotersState> {
    constructor(props : ISongVotersProps) {
        super(props);

        this.state = {
            open: false,
        };
    }

    handleTouchTap = (event) => {
        // This prevents ghost click.
        event.preventDefault();

        this.setState({
            open: true,
            anchorEl: event.currentTarget
        });
    };

    handleRequestClose = () => {
        this.setState({
            open: false
        });
    };

    render() {

        const {voters} = this.props;
        const {userClickHandler} = this.props;

        if (voters.length < 1) {
            return null;
        }

        const listItems = voters.map(eachVote => {
            return (
                <ListItemPlus
                    key={eachVote.createdBy.username}
                    size={35}
                    src={eachVote.createdBy.picture}
                    displayName={eachVote.createdBy.username}
                    itemClick={userClickHandler}/>
            );
        });

        return (
            <MuiThemeProvider>
                <div>
                    <TopVoters voters={voters} clickHandler={this.handleTouchTap}/>
                    <Popover
                        canAutoPosition={false}
                        open={this.state.open}
                        anchorEl={this.state.anchorEl}
                        anchorOrigin={{horizontal: 'left', vertical: 'bottom'}}
                        targetOrigin={{horizontal: 'left', vertical: 'top'}}
                        onRequestClose={this.handleRequestClose}>

                        <List style={{maxHeight: '300px', overflow: 'scroll'}}>
                            <Subheader>Upvoted by</Subheader>
                            <Divider />
                            {listItems}
                        </List>
                    </Popover>
                </div>
            </MuiThemeProvider>
        );
    }

}

export default SongVoters;



// WEBPACK FOOTER //
// ./components/voters/SongVoters.tsx